import React from 'react';
import { Helmet } from 'react-helmet';
import { COMPANY } from '../content/company';
import { HOW_IT_WORKS_STEPS } from '../content/home';
import {
  MEMBERSHIP_INTRO,
  MEMBERSHIP_META,
  MEMBERSHIP_SECTIONS,
  membershipIncludes,
  membershipPriceLine,
  WHO_ITS_FOR,
} from '../content/membership';
import Reveal from '../primitives/Reveal';
import ClosingCta from '../sections/ClosingCta';
import Hero from '../sections/Hero';
import HowItWorks from '../sections/HowItWorks';
import IncludedList from '../sections/IncludedList';
import IntroStatement from '../sections/IntroStatement';
import NumberedSection from '../sections/NumberedSection';

export default function MembershipPage() {
  const priceLine = membershipPriceLine();
  return (
    <>
      <Helmet>
        <title>{MEMBERSHIP_META.title}</title>
        <meta name="description" content={MEMBERSHIP_META.description} />
        <link rel="canonical" href={`${COMPANY.siteUrl}/membership`} />
      </Helmet>

      <Hero image="hero-laptop-sofa" />
      <IntroStatement statement={MEMBERSHIP_INTRO.statement} />

      <NumberedSection id="included" numeral={MEMBERSHIP_SECTIONS.included.numeral} title={MEMBERSHIP_SECTIONS.included.title}>
        <IncludedList items={membershipIncludes()} />
        {priceLine && <p className="t-details" style={{ marginTop: '1.5rem' }}>{priceLine}</p>}
      </NumberedSection>

      <NumberedSection id="how-it-works" numeral={MEMBERSHIP_SECTIONS.how.numeral} title={MEMBERSHIP_SECTIONS.how.title}>
        <HowItWorks steps={HOW_IT_WORKS_STEPS} />
      </NumberedSection>

      <NumberedSection id="who" numeral={MEMBERSHIP_SECTIONS.who.numeral} title={MEMBERSHIP_SECTIONS.who.title}>
        <Reveal>
          <div className="mk-prose t-body">
            {WHO_ITS_FOR.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </Reveal>
      </NumberedSection>

      <ClosingCta
        image="closing-window-coast"
        title="Health, managed."
        body="We haven't opened to new members yet. Join the list and we'll write to you before anyone else."
      />
    </>
  );
}
